const config = {
    cognito: {
      // staging
      // USER_POOL_ID: 'us-east-1_u5qbX7D5W',

      // prod
      USER_POOL_ID: 'us-east-1_nTFKCodN9',

      // staging 
      // CLIENT_ID: '15ph1nkraqa3ei4g7qfgsflseo',

      // prod
      CLIENT_ID: '2qekodfqomhefa017o90q4ei44',

      // staging
      // COGNITO_DOMAIN: 'eloquence',

      // prod
      COGNITO_DOMAIN: 'us-east-1ntfkcodn9',

      // REDIRECT_URI: 'http://localhost:3000/callback'
      // REDIRECT_URI: 'https://staging.d3frhmydlhx99x.amplifyapp.com/callback'
      REDIRECT_URI: 'https://eloquence.sa.aws.dev/callback'
    }
};
  
  export default config;
  
